import { apiInstance } from '@shared/api'

export const getAlarms = async (params?: { offset?: number; limit?: number }) => {
  const res = await apiInstance.get<AlarmListResponse>('/api/v1/alarm', { params })
  return res.data
}

export const postAlarmRead = async () => {
  const res = await apiInstance.post<ApiResponseBase>('/api/v1/alarm/read')
  return res.data
}

export const postAlarmReadOne = async (alarmId: number) => {
  const res = await apiInstance.post<ApiResponseBase>('/api/v1/alarm/read/one', { alarmId })
  return res.data
}

export const deleteAlarms = async () => {
  const res = await apiInstance.delete<ApiResponseBase>('/api/v1/alarm')
  return res.data
}
